/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LayoutOptions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import LayoutOption from './LayoutOption/index'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function LayoutOptions({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/LayoutOptions"
  
}) {
  let isMedia = useIsMedia()
let layoutOptionsValueData = fromData.useDataValue({ viewPath,
context: 'layout_options',
})
  return (<React.Fragment
>
<div
  data-testid="LayoutOptions.List"
  data-view-path={viewPath}
 style={{'--mw-1-ZfuLVX': isMedia.mobile ? "50vw" : "auto"}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(layoutOptionsValueData) && layoutOptionsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="layout_option"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/LayoutOption(${item?.id ?? item?._id ?? index})`}
      >
<LayoutOption
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/LayoutOption(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }